import { render } from "./repairsDetailsModal.vue?vue&type=template&id=3b66e1f8&scoped=true"
import script from "./repairsDetailsModal.vue?vue&type=script&lang=js"
export * from "./repairsDetailsModal.vue?vue&type=script&lang=js"

import "./repairsDetailsModal.vue?vue&type=style&index=0&id=3b66e1f8&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b66e1f8"]])

export default __exports__